/** Configuración clave-valor de la plataforma (spec 11.1). */
export interface PlatformSetting {
  key: string;
  value: string;
  group?: string;
  description?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

/** Agrupación sugerida de claves para el panel. */
export const SETTING_GROUPS: { title: string; keys: { key: string; label: string; hint?: string }[] }[] = [
  {
    title: 'Comisiones',
    keys: [
      {
        key: 'app_fee_percent',
        label: 'Comisión del comprador (%)',
        hint: 'Se suma al precio base del vendedor. Aplica a operaciones nuevas: los pagos ya cobrados conservan su porcentaje, y las ofertas ya pagadas su precio.',
      },
      {
        key: 'seller_commission_percent',
        label: 'Comisión del vendedor (%)',
        hint: 'Se descuenta de su precio base al liberar el payout. Aplica a operaciones nuevas.',
      },
      {
        key: 'tax_percent',
        label: 'IVA (%)',
        hint: 'Las comisiones se cobran con IVA incluido: se desglosa 16/116 de cada comisión al repartir el cobro. Los asientos ya escritos no cambian.',
      },
      {
        key: 'isr_reserve_percent',
        label: 'Reserva de ISR RESICO (%)',
        hint: 'Sobre la comisión sin IVA. Déjalo en 2.5 (la tasa máxima de RESICO): al cerrar el mes en Pagos → Impuestos se paga la tasa real y el sobrante regresa a Ganancias.',
      },
      {
        key: 'expenses_percent',
        label: 'Gastos (%)',
        hint: 'Apartado de gastos sobre tu ganancia bruta, al repartir cada cobro.',
      },
    ],
  },
  {
    title: 'Reembolsos',
    keys: [
      {
        key: 'refund_window_days',
        label: 'Ventana de reembolso (días)',
        hint: 'Sin efecto todavía: ningún proceso bloquea reembolsos por antigüedad.',
      },
      {
        key: 'auto_release_days',
        label: 'Liberación automática (días)',
        hint: 'Días tras confirmar la entrega para liberar el payout. Aplica a las entregas que se confirmen desde ahora; las ya agendadas conservan su fecha.',
      },
    ],
  },
  {
    title: 'Entrega',
    keys: [
      {
        key: 'max_shipping_days',
        label: 'Días máximos de envío',
        hint: 'Plazo del vendedor para enviar, contado desde el cobro. Al cumplirse se avisa a ambas partes; un día después el pedido se cancela y se reembolsa al comprador.',
      },
      {
        key: 'delivery_confirmation_days',
        label: 'Días para confirmar entrega',
        hint: 'Si el comprador no confirma en este plazo tras el envío, el pedido se da por entregado y arranca la liberación del payout.',
      },
      {
        key: 'automation_start_at',
        label: 'Automatismos activos desde',
        hint: 'Los plazos de envío y entrega solo aplican a pedidos cobrados después de esta fecha; los anteriores nunca se cancelan solos. Se graba sola la primera vez y puedes moverla a mano.',
      },
    ],
  },
  {
    title: 'Contenido',
    keys: [
      { key: 'faqs', label: 'FAQs (JSON)' },
      { key: 'privacy_policy', label: 'Aviso de privacidad' },
      { key: 'terms_and_conditions', label: 'Términos y condiciones' },
    ],
  },
];
